import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const REOPEN_BRAND_DEFINITION_TASK = gql`
  ${TASK_VIEW_FIELDS}
  mutation reopenBrandDefinitionTask($id: ID!) {
    reopenBrandDefinitionTask(id: $id) {
      id
      modifiedDate
      reopenedDate
      assignedTo {
        id
        name
      }
      currentViewType
      views {
        ...TaskViewFields
      }
    }
  }
`

export default REOPEN_BRAND_DEFINITION_TASK
